import { render, staticRenderFns } from "./TerminalTable.vue?vue&type=template&id=4060b9ae&scoped=true&"
import script from "./TerminalTable.vue?vue&type=script&lang=js&"
export * from "./TerminalTable.vue?vue&type=script&lang=js&"
import style0 from "./TerminalTable.vue?vue&type=style&index=0&id=4060b9ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060b9ae",
  null
  
)

export default component.exports